import axiosInstance from '@client/utils/axios.util';
import { logger } from '@client/utils/logger.util';

import type { IRevenueEntry, IRevenueWallet } from '@common/types';

export interface IRevenueLedgerResponse {
  entries: IRevenueEntry[];
  total: number;
}

export const getRevenueBalance = async (): Promise<IRevenueWallet> => {
  try {
    const { data } =
      await axiosInstance.get<IRevenueWallet>('/revenue/balance');
    return data;
  } catch (error) {
    logger.error('getRevenueBalance', error);
    throw error;
  }
};

export const getRevenueLedger = async (
  limit: number,
  offset: number,
): Promise<IRevenueLedgerResponse> => {
  try {
    const { data } = await axiosInstance.get<IRevenueLedgerResponse>(
      '/revenue/ledger',
      { params: { limit, offset } },
    );
    return data;
  } catch (error) {
    logger.error('getRevenueLedger', error);
    throw error;
  }
};
